var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 228.7 461"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M224.64 73.24h-.43V27.79c0-15.06-12.19-27.28-27.25-27.29H31.74C16.68.51 4.48 12.73 4.49 27.79v45.45h-.43C2.09 73.24.5 74.83.5 76.8v31.44a3.57 3.57 0 0 0 3.56 3.57h.43v7.5h-.43a3.56 3.56 0 0 0-3.56 3.55v31.44a3.57 3.57 0 0 0 3.56 3.57h.43v275.35c0 15.06 12.19 27.28 27.25 27.29h165.21c15.06 0 27.26-12.23 27.26-27.29V131.09h.43c1.97 0 3.56-1.6 3.56-3.56V76.81a3.57 3.57 0 0 0-3.56-3.57"
  })));
};
export default SvgPhone;